export default "__VITE_ASSET__e67d140e__"